import { OrderType } from './../../shared/models/enums/order-type.enum';
import { AuthService } from './../../shared/services/auth.service';
import { AddressesService } from './../../shared/services/addresses.service';
import { DictionaryValuesService } from '../../shared/services/dictionaryValues.service';
import { ClientsService } from './../../shared/services/clients.service';
import { SitesService } from './../../shared/services/sites.service';
import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  OnInit,
  Output,
} from '@angular/core';
import { Router } from '@angular/router';
import { trigger, state, style } from '@angular/animations';
import { MatTableDataSource } from '@angular/material/table';
import { PageEvent } from '@angular/material/paginator';
import { Sort } from '@angular/material/sort';
import { DatatableBaseComponent } from '@components/datatable-base.component';
import { UiService } from '@services/ui.service';
import { Order } from '@classes/order/order';
import { OrdersService } from '@services/orders.service';
import { OrderStatus } from '@enums/order-status.enum';
import { Pagination } from '@classes/pagination/pagination';
import { PaginationRequest } from '@classes/pagination/pagination-request';
import {
  UntypedFormGroup,
  UntypedFormControl,
  UntypedFormBuilder,
} from '@angular/forms';
import { SelectionModel } from '@angular/cdk/collections';
import { User } from '@classes/user/user';
import { Client } from '@classes/client';
import { Site } from '@classes/site';
import { SiteGroup } from '@classes/site-group';
import { SiteGroupsService } from '@services/site-groups.service';
import { Address } from '@classes/address';
import { UsersService } from '@services/users.service';
import { RoleName } from '@enums/role-name.enum';
import { DictionaryValue } from '@classes/dictionary/dictionaryValue';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { MatDialog } from '@angular/material/dialog';
import { DialogChangeTimespentComponent } from '@components/dialog-change-timespent/dialog-change-timespent.component';

@Component({
  selector: 'app-missions-list',
  templateUrl: './missions-list.component.html',
  styleUrls: ['./missions-list.component.scss'],
  animations: [
    trigger('detailExpand', [
      state(
        'collapsed',
        style({ height: '0px', minHeight: '0', display: 'none' }),
      ),
      state('expanded', style({ height: '*' })),
    ]),
  ],
})
export class MissionsListComponent
  extends DatatableBaseComponent
  implements OnInit
{
  @Output() clearOneFilterEvent = new EventEmitter<any>();

  orders: Order[];
  indexToRemove = null;

  displayedColumns: string[] = [];
  displayedColumnsMenuMissions: any[] = [
    { editable: false, name: 'select', selected: true, visible: false },
    { editable: true, name: 'identifier', selected: true, visible: false },
    { editable: true, name: 'startDate', selected: true, visible: false },
    { editable: true, name: 'name', selected: true, visible: false },
    { editable: true, name: 'urgency', selected: true, visible: false },
    { editable: true, name: 'sender', selected: true, visible: false },
    { editable: true, name: 'receivers', selected: true, visible: false },
    { editable: true, name: 'status', selected: true, visible: false },
    { editable: true, name: 'type', selected: true, visible: false },
    { editable: true, name: 'client', selected: true, visible: false },
    { editable: true, name: 'site', selected: true, visible: false },
    { editable: true, name: 'createdBy', selected: true, visible: false },
    { editable: true, name: 'createdOn', selected: true, visible: false },
    { editable: true, name: 'driver', selected: true, visible: false },
    { editable: true, name: 'timeSpent', selected: true, visible: false },
    { editable: false, name: 'actions', selected: true, visible: false },
  ];

  // Additional 'filter' column list
  displayedColumnFilters: string[] = ['identifier-filter'];
  dataSource: MatTableDataSource<Order>;
  orderStatus = OrderStatus;

  // filterValue: string;
  filterValue = null;
  pagination: Pagination;
  sortValue: string = '-startDate';

  dispatchers: User[];
  clients: Client[];
  sites: Site[];
  siteGroups: SiteGroup[] = [];
  urgencies: DictionaryValue[];
  senders: Address[];
  receivers: Address[];
  users: User[];
  usersDrivers: User[];

  isLoadingFilterForm: boolean;

  globalFilter = '';
  canExport = false;

  useSubcontractorPrices = false;

  filterForm = new UntypedFormGroup({
    identifier: new UntypedFormControl(),
    status: new UntypedFormControl(),
    name: new UntypedFormControl(),
    type: new UntypedFormControl(),
    dispatcher: new UntypedFormControl(),
    client: new UntypedFormControl(),
    site: new UntypedFormControl(),
    siteGroup: new UntypedFormControl(),
    createdBy: new UntypedFormControl(),
    startDate: new UntypedFormControl(),
    range: new UntypedFormGroup({
      fromStartDate: new UntypedFormControl(null),
      toStartDate: new UntypedFormControl(null),
    }),
    urgency: new UntypedFormControl(),
    sender: new UntypedFormControl(),
    receiver: new UntypedFormControl(),
    driver: new UntypedFormControl(),
    includeDeleted: new UntypedFormControl(),
  });

  filteredValues = {
    identifier: '',
    startDate: '',
    status: '',
    type: '',
    dispatcher: '',
    client: '',
    site: '',
    siteGroup: '',
    createdBy: '',
    urgency: '',
    sender: '',
    receiver: '',
    driver: '',
  };

  isDispatcher: boolean;
  isAdmin: boolean;

  initialSelection = [];
  allowMultiSelect = true;
  selection = new SelectionModel<any>(
    this.allowMultiSelect,
    this.initialSelection,
  );

  allStatus: any[] = [
    {
      value: 'all',
      name: 'Tous',
    },
    {
      value: 16,
      name: 'Terminée',
    },
    {
      value: 32,
      name: 'Annulée',
    },
  ];

  allType: any[] = [
    {
      value: 'all',
      name: 'Tous',
    },
    {
      value: OrderType.client,
      name: 'Classique',
    },
    {
      value: OrderType.transmission,
      name: 'Transmission',
    },
    {
      value: OrderType.tour,
      name: 'Tournée',
    },
  ];

  // expose enum to template
  orderType = OrderType;

  constructor(
    protected uiSrv: UiService,
    protected fb: UntypedFormBuilder,
    private ordersSrv: OrdersService,
    private router: Router,
    private sitesSrv: SitesService,
    private siteGroupsSrv: SiteGroupsService,
    private clientsSrv: ClientsService,
    private dictionarySrv: DictionaryValuesService,
    private addressesSrv: AddressesService,
    private usersSrv: UsersService,
    private authSrv: AuthService,
    public dialog: MatDialog,
    private ref: ChangeDetectorRef,
  ) {
    super(uiSrv);
  }

  ngOnInit() {
    if (sessionStorage.getItem('missionFilters')) {
      this.filterValue = JSON.parse(sessionStorage.getItem('missionFilters'));
    }

    this.isDispatcher =
      this.authSrv.getUser().role.name === RoleName.bizzdev ||
      this.authSrv.getUser().role.name === RoleName.super_admin ||
      this.authSrv.getUser().role.name === RoleName.admin ||
      this.authSrv.getUser().role.name === RoleName.admin_subcontractor ||
      this.authSrv.getUser().role.name === RoleName.dispatcher;

    this.canExport =
      this.authSrv.getUser().role.name === RoleName.bizzdev ||
      this.authSrv.getUser().role.name === RoleName.super_admin ||
      this.authSrv.getUser().role.name === RoleName.admin ||
      this.authSrv.getUser().role.name === RoleName.admin_subcontractor ||
      this.authSrv.getUser().role.name === RoleName.admin_client ||
      this.authSrv.getUser().role.name === RoleName.dispatcher ||
      this.authSrv.getUser().role.name === RoleName.driver;

    this.isAdmin =
      this.authSrv.getUser().role.name === RoleName.bizzdev ||
      this.authSrv.getUser().role.name === RoleName.super_admin ||
      this.authSrv.getUser().role.name === RoleName.admin ||
      this.authSrv.getUser().role.name === RoleName.admin_subcontractor;

    super.ngOnInit();
    this.checkIfColumnsInStorage();
    this.initSubscriptions();
  }

  ngAfterViewInit(): void {
    if (sessionStorage.getItem('missionFilters')) {
      this.initForm();
    }
  }

  ngAfterViewChecked(): void {
    this.ref.detectChanges();
  }

  checkIfColumnsInStorage(): void {
    if (localStorage.getItem('displayedColumnsMenuMissions')) {
      this.displayedColumnsMenuMissions = JSON.parse(
        localStorage.getItem('displayedColumnsMenuMissions'),
      );
    } else {
      this.displayedColumnsMenuMissions = [
        { editable: false, name: 'select', selected: true, visible: false },
        { editable: true, name: 'identifier', selected: true, visible: false },
        { editable: true, name: 'startDate', selected: true, visible: false },
        { editable: true, name: 'name', selected: true, visible: false },
        { editable: true, name: 'urgency', selected: true, visible: false },
        { editable: true, name: 'sender', selected: true, visible: false },
        { editable: true, name: 'receivers', selected: true, visible: false },
        { editable: true, name: 'status', selected: true, visible: false },
        { editable: true, name: 'type', selected: true, visible: false },
        { editable: true, name: 'client', selected: true, visible: false },
        { editable: true, name: 'site', selected: true, visible: false },
        { editable: true, name: 'createdBy', selected: true, visible: false },
        { editable: true, name: 'createdOn', selected: true, visible: false },
        { editable: true, name: 'driver', selected: true, visible: false },
        { editable: true, name: 'timeSpent', selected: true, visible: false },
        { editable: false, name: 'actions', selected: true, visible: false },
      ];
    }
  }

  containsObject(obj, list) {
    var i;
    for (i = 0; i < list.length; i++) {
      if (list[i].name === obj.name) {
        this.indexToRemove = i;
        return true;
      }
    }

    return false;
  }

  showStatusText(status: OrderStatus): string {
    return 'orders.status.' + OrderStatus[status];
  }

  showTypeText(type: OrderType): string {
    return 'orders.type.' + OrderType[type];
  }

  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    this.isAllSelected()
      ? this.selection.clear()
      : this.dataSource.data.forEach((row) => this.selection.select(row));
  }

  onFilter(): void {
    this.selection.clear();
    const formValue = this.filterForm.value;

    this.filterValue = formValue;
    this.saveFilterInSessionStorage();
    this.getList();
  }

  clearFilters(): void {
    this.filterForm.reset();
    this.filterValue = null;
    this.clearFilterSessionStorage();
    this.getList();
  }

  filterEnter(event: Event, column) {
    this.filterValue = this.filterForm.value;
    this.saveFilterInSessionStorage();
    this.getList();
  }

  initForm() {
    const filterValue = this.filterValue;

    let site = filterValue.site;
    let createdBy = filterValue.createdBy;

    if (filterValue.site && typeof filterValue.site !== 'string') {
      site = Site.fromObject(site);
    }

    if (filterValue.createdBy && typeof filterValue.createdBy !== 'string') {
      createdBy = User.fromObject(createdBy);
    }

    const siteGroup = filterValue.siteGroup
      ? SiteGroup.fromObject(filterValue.siteGroup)
      : null;

    this.filterForm = new UntypedFormGroup({
      identifier: new UntypedFormControl(filterValue.identifier),
      status: new UntypedFormControl(filterValue.status),
      name: new UntypedFormControl(filterValue.name),
      type: new UntypedFormControl(filterValue.type),
      dispatcher: new UntypedFormControl(filterValue.dispatcher),
      client: new UntypedFormControl(filterValue.client),
      site: new UntypedFormControl(site),
      siteGroup: new UntypedFormControl(siteGroup),
      createdBy: new UntypedFormControl(createdBy),
      startDate: new UntypedFormControl(filterValue.startDate),
      range: new UntypedFormGroup({
        fromStartDate: new UntypedFormControl(filterValue.range.fromStartDate),
        toStartDate: new UntypedFormControl(filterValue.range.toStartDate),
      }),
      urgency: new UntypedFormControl(filterValue.urgency),
      sender: new UntypedFormControl(filterValue.sender),
      receiver: new UntypedFormControl(filterValue.receiver),
      driver: new UntypedFormControl(filterValue.driver),
      includeDeleted: new UntypedFormControl(filterValue.includeDeleted),
    });
  }

  saveFilterInSessionStorage() {
    sessionStorage.setItem('missionFilters', JSON.stringify(this.filterValue));
  }

  clearFilterSessionStorage() {
    sessionStorage.removeItem('missionFilters');
  }

  onPageChanged(pageEvent: PageEvent): void {
    this.selection.clear();
    this.pagination.pageNumber = pageEvent.pageIndex + 1;
    this.getList();
  }

  onSortChanged(sortEvent: Sort): void {
    let direction = '';

    if (sortEvent.direction === 'asc') {
      direction = '';
    } else if (sortEvent.direction === 'desc') {
      direction = '-';
    }
    if (sortEvent.direction === '') {
      this.sortValue = null;
    } else {
      this.sortValue = ` ${direction}${sortEvent.active}`;
    }
    this.getList();
  }

  get canShowSubcontractorToggle(): boolean {
    const userRole = this.authSrv.getUser().role.name;
    return userRole === RoleName.admin || userRole === RoleName.super_admin || userRole === RoleName.bizzdev;
  }

  get shouldUseSubcontractorMode(): boolean {
    const userRole = this.authSrv.getUser().role.name;
    if (userRole === RoleName.admin_subcontractor) {
      return true;
    }
    return this.useSubcontractorPrices;
  }

  onExportLetters(): void {
    this.ordersSrv.generateAllLettersPdf(this.filterValue).subscribe(() => {
      this.uiSrv.showSnackbar(
        "Votre demande d'export à été faite. Vous recevrez une notification lorsque vos documents seront prêts.",
        false,
        5000,
      );
    });
  }

  onExport(): void {
    const idOrders = [];
    this.selection.selected.map((order) => {
      idOrders.push(order.id);
    });
    const useSubcontractorMode = this.shouldUseSubcontractorMode;
    this.ordersSrv.exportExcel(idOrders, true, useSubcontractorMode).subscribe(() => {
      this.selection.clear();
    });
  }

  onExportAll(): void {
    const newRequest = new PaginationRequest(
      this.filterValue,
      null,
      null,
      null,
    );
    const useSubcontractorMode = this.shouldUseSubcontractorMode;
    this.ordersSrv.exportExcelAll(newRequest, true, false, useSubcontractorMode).subscribe(() => {});
  }

  onSelectOrder(id: string): void {
    this.router.navigate([`orders/${id}`]);
  }

  getList(): void {
    const newRequest = new PaginationRequest(
      this.filterValue,
      this.sortValue,
      this.pagination.pageNumber,
    );

    this.ordersSrv.getList(newRequest, true);
  }

  private initTable(): void {
    this.dataSource = new MatTableDataSource(this.orders);
    this.dataSource.sort = this.sort;
  }

  private savePageNumberInSessionStorage(): void {
    if (this.pagination && this.pagination.pageNumber) {
      sessionStorage.setItem(
        'missionPage',
        this.pagination.pageNumber.toString(),
      );
    }
  }

  private initSubscriptions(): void {
    this.addSubscription(
      this.ordersSrv.ordersListChanged.subscribe((orders) => {
        this.orders = orders;
        this.setDisplayedColumns();
        this.initTable();
      }),
    );

    this.addSubscription(
      this.ordersSrv.paginationSubject.subscribe((pagination) => {
        if (this.pagination) {
          this.pagination = pagination;
          this.savePageNumberInSessionStorage();
        } else {
          this.pagination = pagination;
        }
      }),
    );

    const page = parseInt(sessionStorage.getItem('missionPage')) || 1;
    const newRequest = new PaginationRequest(
      this.filterValue,
      this.sortValue,
      page,
    );
    this.ordersSrv.getList(newRequest, true, true);

    this.isLoadingFilterForm = true;

    const sitesPromise = new Promise((resolve, reject) => {
      this.sitesSrv.getList().subscribe((sitesFromSrv) => {
        this.sites = sitesFromSrv;
        resolve(true);
      });
    });

    const siteGroupsPromise = new Promise((resolve, reject) => {
      this.siteGroupsSrv.getList().subscribe((siteGroupsFromSrv) => {
        this.siteGroups = siteGroupsFromSrv;
        resolve(true);
      });
    });

    const clientsPromise = new Promise((resolve, reject) => {
      this.clientsSrv.getList().subscribe((clientsFromSrv) => {
        this.clients = clientsFromSrv;
        resolve(true);
      });
    });

    const urgencyLevelsPromise = new Promise((resolve, reject) => {
      this.dictionarySrv.getUrgencyList().subscribe((urgencyLevelsFromSrv) => {
        this.urgencies = urgencyLevelsFromSrv;
        resolve(true);
      });
    });

    const addressPromise = new Promise((resolve, reject) => {
      this.addressesSrv.getList().subscribe((addressessFromSrv) => {
        this.senders = addressessFromSrv.filter((address) => address.isSender);
        this.receivers = addressessFromSrv.filter(
          (address) => address.isReceiver,
        );
        resolve(true);
      });
    });

    const usersPromise = new Promise((resolve, reject) => {
      this.usersSrv.getList().subscribe((usersFromSrv) => {
        let system = new User('Système', null, null, null, null, null);
        system.id = 'system';
        let all = new User('Tous', null, null, null, null, null);
        all.id = 'all';
        this.users = usersFromSrv;
        this.usersDrivers = [...usersFromSrv].filter(
          (oneDriver) =>
            oneDriver.role.name !== RoleName.admin_client &&
            oneDriver.role.name !== RoleName.client,
        );
        this.users.push(system);
        this.users.push(all);
        resolve(true);
      });
    });

    Promise.all([
      sitesPromise,
      siteGroupsPromise,
      clientsPromise,
      urgencyLevelsPromise,
      addressPromise,
      usersPromise,
    ]).then(() => {
      this.isLoadingFilterForm = false;
    });
  }

  changeStatus(status: string, order: Order): void {
    const statusToSend = {
      status: 0,
      comment: null,
    };

    let canSend = true;

    if (status === 'receivedByDispatcher') {
      statusToSend.status = 2;
    } else if (status === 'treatedByDispatcher') {
      statusToSend.status = 4;
    } else if (status === 'finished') {
      statusToSend.status = 16;
      canSend = confirm('Etes-vous certain de terminer cette commande ?');
    } else if (status === 'cancelled') {
      statusToSend.status = 32;
      canSend = confirm("Etes-vous certain d'annuler cette commande ?");
    }

    if (canSend) {
      this.ordersSrv
        .changeStatus(order.id, statusToSend)
        .subscribe((results) => {
          order.status = results.status;
          order.statusChanges = results.statusChanges;
        });
    }
  }

  delete(order: Order): void {
    const confirmation = confirm(
      'Êtes-vous certain de vouloir supprimer cette mission ?',
    );
    if (confirmation) {
      this.ordersSrv.delete(order.id).subscribe(() => {
        this.uiSrv.showSnackbar('Mission supprimée avec succès', false);
      });
    }
  }

  drop(event: CdkDragDrop<string[]>) {
    // Swap the elements around
    moveItemInArray(
      this.displayedColumnsMenuMissions,
      event.previousIndex,
      event.currentIndex,
    );
    localStorage.setItem(
      'displayedColumnsMenuMissions',
      JSON.stringify(this.displayedColumnsMenuMissions),
    );
    this.setDisplayedColumns();
  }

  onSelectMenu(event, name) {
    this.displayedColumnsMenuMissions.find((f) => f.name === name).selected =
      event.checked;
    localStorage.setItem(
      'displayedColumnsMenuMissions',
      JSON.stringify(this.displayedColumnsMenuMissions),
    );
    this.setDisplayedColumns();
  }

  private setDisplayedColumns(): void {
    this.displayedColumns = this.displayedColumnsMenuMissions
      .filter((f) => (f || {}).selected)
      .map((m) => m.name);
  }

  getControl(control: string): UntypedFormControl {
    return this.filterForm.get(control) as UntypedFormControl;
  }

  compareSiteGroup(a: SiteGroup, b: SiteGroup): boolean {
    return a?.id === b?.id;
  }

  get isSiteGroupIgnored(): boolean {
    return !!this.filterForm.value.site && !!this.filterForm.value.siteGroup;
  }

  changeTimeSpent(order: Order) {
    const dialogRef = this.dialog.open(DialogChangeTimespentComponent, {
      width: '250px',
      data: { orderId: order.id },
    });

    dialogRef.afterClosed().subscribe((result) => {});
  }
}
